import React from 'react';
import Icon, { Icons } from '../../Icon/Icon';
import styles from './Button.module.css'
import Spinner from '../../Spinner/Spinner';
import { cn } from '@/utils/cn';
export const Variants = {
    primarySolid: 'button-solid-primary',
    secondarySolid: 'button-solid-secondary',
    destructiveSolid: 'button-solid-destructive',
    primaryBorder: 'button-border-primary',
    secondaryBorder: 'button-border-secondary',
    destructiveBorder: 'button-border-destructive',
    none: ''
}

export const Sizes = {
    small: 'button-size-small',
    default: 'button-size-default',
    large: 'button-size-large',
    none: '',
}

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    icon?: Icons;
    variant?: keyof typeof Variants;
    size?: keyof typeof Sizes;
    type?: 'button' | 'submit' | 'reset';
    className?: string; // Should only be used for layout purposes e.g. flex or inline-block.
    loading?: boolean;
    'data-state'?: 'hover'|'focus'|'active';

}

const Button = ({ children, icon, type = 'button', variant = 'primarySolid', size = 'default', className, loading, ...rest }: Props) => {
    const classNames = cn('button', Variants[variant], Sizes[size], (loading) ? styles.ButtonLoading : '', className);

    return (
        <button type={type} className={classNames} {...rest} data-state={(loading) ? 'loading' : rest['data-state']} >
            {children}
            {
                (loading) &&
                <Spinner className={styles.ButtonSpinner} />
            }
            {icon && <Icon icon={icon} />}
        </button>
    );
};

export default Button;
